import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface BlockingPageProps {
  title: string;
  message: string;
  actions?: { label: string; onClick: () => void; variant?: "default" | "outline" }[];
}

export const BlockingPage = ({ title, message, actions }: BlockingPageProps) => (
  <div className="min-h-screen flex items-center justify-center bg-background p-4">
    <Card className="p-6 max-w-md text-center">
      <CardHeader>
        <CardTitle className="text-2xl font-bold text-destructive">⚠️ {title}</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground mt-3">{message}</p>
        {actions && (
          <div className="mt-6 space-y-3">
            {actions.map((action, index) => (
              <Button key={index} onClick={action.onClick} variant={action.variant} className="w-full">
                {action.label}
              </Button>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  </div>
);